export default __webpack_public_path__ + "static/media/person_1@2x.68c89b50.png";